const configuredApiUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
// Production requests go through Pages Functions on the storefront's origin.
// Keep an absolute URL because image/report consumers also use this value.
const API_BASE_URL = configuredApiUrl && configuredApiUrl !== '/'
  ? configuredApiUrl.replace(/\/+$/, '')
  : process.env.NODE_ENV === 'production' || configuredApiUrl === '/'
    ? window.location.origin
    : 'http://localhost:5000';
const AUTH_TOKEN_STORAGE_KEY = 'iconnectstore_auth_token';

export { API_BASE_URL, AUTH_TOKEN_STORAGE_KEY };
